<script setup>
import { onMounted } from 'vue';

onMounted(() => {
    const cards = document.querySelectorAll('.req-card');
    const observer = new window.IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        },
        { threshold: 0.1 }
    );
    cards.forEach(card => observer.observe(card));
});
</script>

<template>
    <div class="employment-page">
        <!-- Hero -->
        <div class="emp-hero">
            <div class="emp-hero-content">
                <h1 class="emp-hero-title">採用情報</h1>
                <p class="emp-hero-sub">私たちと一緒に働きませんか？</p>
            </div>
        </div>

        <div class="container">
            <!-- 募集要項ヘッダー -->
            <section class="recruit-header">
                <h2 class="section-title">募集要項</h2>
                <p class="recruit-types">中途採用・新卒採用・協力会社</p>
            </section>

            <!-- 詳細グリッド -->
            <div class="req-grid">
                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>雇用形態</h3>
                    <p>正社員・業務委託</p>
                </div>

                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>募集職種</h3>
                    <p>足場 鳶工事・電気工事業<br>（防犯カメラ取付、エアコン取付）</p>
                </div>

                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>勤務地</h3>
                    <p>
                        主に一都三県（東京／神奈川／埼玉／千葉）の現場に配属になります。<br>
                        お住まいからなるべく近いよう考慮します。<br>
                        通勤方法は電車・バイク・車（現場によりけり）の直行直帰通勤になります。<br>
                        会社近辺にお住まいの方は相乗りも可能です。
                    </p>
                </div>

                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>給与</h3>
                    <div class="salary-table">
                        <div class="salary-row highlight">
                            <span class="salary-label">月収</span>
                            <span class="salary-value">３２万円～</span>
                        </div>
                        <div class="salary-row">
                            <span class="salary-label">未経験者</span>
                            <span class="salary-value">日当 １３，０００円以上</span>
                        </div>
                        <div class="salary-row">
                            <span class="salary-label">経験者</span>
                            <span class="salary-value">日当 １４，０００円～２４，０００円</span>
                        </div>
                        <p class="salary-note">その他、歩合給・各種手当あり</p>
                    </div>
                </div>

                <div class="req-card wide">
                    <div class="req-icon"></div>
                    <h3>福利厚生</h3>
                    <ul class="benefits-list">
                        <li>賞与・ボーナス年２回</li>
                        <li>週休２日</li>
                        <li>通勤交通費支給</li>
                        <li>社宅完備</li>
                        <li>作業服・工具支給あり</li>
                        <li>労災保険</li>
                        <li>雇用保険</li>
                        <li>厚生年金</li>
                        <li>健康保険</li>
                        <li>社会保険</li>
                        <li>資格取得全額支給</li>
                        <li>育児休暇制度</li>
                        <li>残業代完全支給</li>
                        <li>利益インセンティブあり</li>
                        <li>年末年始長期休暇</li>
                        <li>夏季・冬季休暇</li>
                        <li>紹介手当</li>
                    </ul>
                </div>

                <div class="req-card wide">
                    <div class="req-icon"></div>
                    <h3>歓迎資格</h3>
                    <ul class="qualifications-list">
                        <li>とび一級技能士</li>
                        <li>玉掛け</li>
                        <li>足場の組立等作業主任者</li>
                        <li>高所作業車10m以上</li>
                        <li>小型移動式クレーン</li>
                        <li>フォークリフト</li>
                        <li>職長安全衛生主任者</li>
                        <li>電気工事１種・２種</li>
                    </ul>
                </div>

                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>対象者</h3>
                    <p>学歴・年齢不問<br>未経験者歓迎・経験者優遇</p>
                </div>

                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>勤務時間</h3>
                    <p>８時～１７時<br>８時半～１７時</p>
                </div>

                <div class="req-card">
                    <div class="req-icon"></div>
                    <h3>休日</h3>
                    <p>
                        シフト制（日曜＋１日の週休２日あり）<br>
                        <span class="note">※収入を上げたい方は週６日勤務可能</span><br>
                        週・月ごとに変更可能
                    </p>
                </div>
            </div>

            <!-- 応募CTA -->
            <div class="cta-section">
                <h3>お気軽にお問い合わせください</h3>
                <p>TEL: <a href="tel:08044262237">080-4426-2237</a></p>
                <p>Mail: <a href="mailto:masakiryuki947@gmail.com">masakiryuki947@gmail.com</a></p>
                <p>LINE ID: @owi7912d</p>
            </div>
        </div>
    </div>
</template>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    .employment-page {
        font-family: 'Noto Serif JP', 'Hiragino Mincho ProN', 'Yu Mincho', 'YuMincho', serif;
        line-height: 1.6;
        color: #ffffff;
        background-color: #000000;
        padding-top: 80px;
    }

    .emp-hero {
        background: linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(26,26,26,0.65) 60%, rgba(255,128,48,0.2) 100%),
                    url('@/assets/Home.jpg') center/cover no-repeat;
        color: white;
        padding: 80px 20px;
        text-align: center;
    }

    .emp-hero-title {
        font-size: 3rem;
        font-weight: bold;
        text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        margin-bottom: 16px;
    }

    .emp-hero-sub {
        font-size: 1.3rem;
        opacity: 0.9;
    }

    .container {
        max-width: 1100px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .recruit-header {
        padding: 60px 0 20px;
        text-align: center;
    }

    .section-title {
        font-size: 2.2rem;
        color: #ffffff;
        position: relative;
        display: inline-block;
        margin-bottom: 16px;
    }

    .section-title::after {
        content: '';
        display: block;
        width: 80px;
        height: 4px;
        background: #ff8030;
        margin: 12px auto 0;
        border-radius: 2px;
    }

    .recruit-types {
        font-size: 1.1rem;
        color: #ff8030;
        font-weight: 600;
        margin-bottom: 40px;
    }

    .req-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        padding-bottom: 60px;
    }

    .req-card {
        background: #0f0f0f;
        border-radius: 12px;
        padding: 32px;
        border-left: 5px solid #ff8030;
        box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.5s ease, transform 0.5s ease, box-shadow 0.3s ease;
    }

    .req-card.visible {
        opacity: 1;
        transform: translateY(0);
    }

    .req-card:hover {
        box-shadow: 0 8px 24px rgba(255,128,48,0.25);
    }

    .req-card.wide {
        grid-column: span 2;
    }

    .req-icon {
        font-size: 2rem;
        margin-bottom: 12px;
    }

    .req-card h3 {
        font-size: 1.2rem;
        color: #ff8030;
        font-weight: 700;
        margin-bottom: 12px;
    }

    .req-card p {
        font-size: 1rem;
        color: #e0e0e0;
        line-height: 1.8;
    }

    .salary-table {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .salary-row {
        display: flex;
        align-items: center;
        gap: 16px;
        background: #181818;
        padding: 10px 16px;
        border-radius: 8px;
    }

    .salary-row.highlight {
        background: #3d2a1a;
        border: 1px solid #ff8030;
    }

    .salary-label {
        font-size: 0.85rem;
        color: #aaaaaa;
        min-width: 70px;
        flex-shrink: 0;
    }

    .salary-value {
        font-size: 1rem;
        font-weight: 600;
        color: #ffffff;
    }

    .salary-note {
        font-size: 0.9rem;
        color: #aaaaaa;
        padding-left: 4px;
    }

    .benefits-list,
    .qualifications-list {
        list-style: none;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 10px;
    }

    .benefits-list li,
    .qualifications-list li {
        background: #181818;
        padding: 10px 16px;
        border-radius: 8px;
        font-size: 0.95rem;
        color: #e0e0e0;
        position: relative;
        padding-left: 28px;
    }

    .benefits-list li::before,
    .qualifications-list li::before {
        content: '✓';
        position: absolute;
        left: 10px;
        color: #ff8030;
        font-weight: bold;
    }

    .note {
        font-size: 0.9rem;
        color: #aaaaaa;
    }

    .cta-section {
        background: #0a0a0a;
        border: 1px solid rgba(255,128,48,0.4);
        color: white;
        text-align: center;
        padding: 60px 20px;
        border-radius: 16px;
        margin-bottom: 60px;
        box-shadow: 0 4px 20px rgba(255,128,48,0.1);
    }

    .cta-section h3 {
        font-size: 1.8rem;
        margin-bottom: 24px;
    }

    .cta-section p {
        font-size: 1.1rem;
        margin-bottom: 12px;
    }

    .cta-section a {
        color: #ff8030;
        text-decoration: underline;
        font-weight: 600;
    }

    .cta-section a:hover {
        opacity: 0.85;
    }

    @media (max-width: 768px) {
        .emp-hero-title {
            font-size: 2.2rem;
        }

        .req-grid {
            grid-template-columns: 1fr;
        }

        .req-card.wide {
            grid-column: span 1;
        }

        .benefits-list,
        .qualifications-list {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        }
    }
</style>
